/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Button, Card, CardContent, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import { GridSearchIcon } from "@mui/x-data-grid";
import axios from "axios";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import MDButton from "components/MDButton";
import DeleteModal from "components/deletemodal/deletemodal";
import BillingModal from "components/displayModel/billingModel";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useCallback, useEffect, useState } from "react";
import { createTheme } from "react-data-table-component";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { deleteExpenses, fetchedExpenses, getCurrencyCode } from "utils/api";
import { appConstants } from "utils/appConstants";
import { generateDataList, getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import useFeatureAccess from "utils/useFeatureAccess";
import LoadingModal from "../../components/LoadingModel/loadingModal";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IconMenu from "components/CustomMaterialMenu/Custom";
import { formatCurrencyAUD } from "utils/formatCurrency";

let searchParameter = "";
let name = "";
let categoryCodeName = "";

createTheme(
  'solarized',
  {
    text: {
      primary: 'white',
      secondary: 'white',
    },
    background: {
      default: '#202940',
    },
    context: {
      background: '#202940',
      text: 'white',
    },
    divider: {
      default: 'white',
    },
    sortFocus: {
      default: '#2aa198',
    },
  },
  'dark',
);
createTheme(
  'light',
  {
    text: {
      primary: 'black',
      secondary: 'black',
    },
    background: {
      default: 'white',
    },
    context: {
      background: 'white',
      text: 'black',
    },
    divider: {
      default: 'gray',
    },
    sortFocus: {
      default: '#2aa198',
    },
  },
  'dark',
);
const SCREEN_NAME = "Expenses"
let SCREEN_RIGHT;

function Expenses() {
  //Starts here change the pagination text Rows per page to Record per page
  let changePaginationText = document.getElementsByClassName("rdt_Pagination")[0];
  if (changePaginationText !== undefined) {
    changePaginationText.getElementsByTagName("span")[0].textContent = "Records Per Page";
  }  //ends here change the pagination text Rows per page to Record per page
  const navigate = useNavigate();
  const featureAccess = useFeatureAccess();
  const [loading, setLoading] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [deleteHeading, setDeleteHeading] = useState("");
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [title, setTitle] = useState("");
  const [controller] = useMaterialUIController();
  const dispatch = useDispatch();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const [currencyCode, setCurrencyCode] = useState("");
  const [showBillingModal, setShowBillingModal] = useState(false);
  const [screenAccess, setScreenAccess] = useState(false);
  const [values, setValues] = useState({
    _id: '',
    sortingType: "",
    sortingField: "",
    name: "All",
    categoryCodeName: "All",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    searchParameterList: ['categoryCodeName', 'name', 'expenseDate', 'totalAmount', 'taxAmount', 'tipAmount', 'notes', 'companyName'],
    businessUserID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?.businessUserID,
  });

  const [itemCategoriesName, setItemCategoriesName] = useState([]);
  const [contactTypeName, setContactTypeName] = useState([]);

  useEffect(() => {
    (async () => {
      await getRight();
      await fetchCurrencyValue();
      await fetchCategories();
      await fetchExpenses();
      await fetchContactType();
    })();

  }, [values.categoryCodeName, values.name, values.sortingType, perPage, dispatch]);

  async function getRight() {
    SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
    setScreenAccess(SCREEN_RIGHT === 'Full Access' ? true : false);
  }
  let fetchCurrencyValue = async () => {
    await getCurrencyCode({ businessUserID: values.businessUserID }, (data => {
      if (data.Result_Status) {
        setCurrencyCode(data.Result_Output)
      }
    }), dispatch);
  }
  const handleCancel = (name) => (event) => {
    setSelectedRows([]);
    setDeleteDialogeFlag(false);
  };

  const handleDeleteDialogeClick = async (_id) => {
    values._id = _id;
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleDelete = async (id) => {
    deleteRecord();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handlePageChange = page => {
    values.page = page;
    fetchExpenses();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };

  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };

  let fetchCategories = async () => {
    await axios
      .post(appConstants.baseURL + "items/fetchCategoriesData", { businessUserID: values.businessUserID })
      .then(
        async (res) => {
          let response = res.data.fetchCategories;
          setItemCategoriesName(await generateDataList(response, "categoryCodeName", "categoryCodeName"));
        }
      )
      .catch(
        (error) => {
          console.log("Error in Fetching" + JSON.stringify(error))
          setLoading(false); console.log(error)
        }
      )
  }

  let fetchContactType = async () => {
    await axios
      .post(appConstants.baseURL + "expenses/ContactData", values)
      .then(
        async (res) => {
          let response = res.data.fetchContactType;
          setContactTypeName(await generateDataList(response, "name", "name"));
        }
      )
      .catch(
        (error) => {
          console.log("Error in Fetching" + JSON.stringify(error))
          setLoading(false); console.log(error)
        }
      )
  }

  const handleRowSelected = useCallback(state => {
    setSelectedRows(state.selectedRows);
    if (state.selectedRows.length > 0) {
      setTitle(" ");
    }
    else {
      setTitle("");
      setDeleteHeading("");
    }
  }, []);

  const deleteRecord = async () => {
    await deleteExpenses(values, (data) => {
      fetchExpenses();
      setToggleCleared(true);
      setTitle("");
      showResMsg(data.Result_Status ? genericMessage.deleted : data.Result_Message, 1000, data.Result_Status);
    }, dispatch)
  };

  const fetchExpenses = async () => {
    await fetchedExpenses(values, (data) => {
      setTotalRows(data.Result_Output.totalDocs);
      setRows(data.Result_Output.docs)
    }, dispatch)
  };

  useEffect(() => {
    name = values.name;
    categoryCodeName = values.categoryCodeName;
  }, [values.name, values.categoryCodeName]);


  const customStyles = {
    table: {
      style: {
        borderColor: tableBorder,
      },
    },
    headRow: {
      style: {
        color: darkMode ? "white" : "white",
        background: barColor,
      },
    },
    headCells: {
      style: {
        // paddingLeft: '10px',
        // paddingRight: '10px',
        fontWeight: 'bold',
        fontSize: '14px',
        color: "white",

      },
    },
  };

  let columns = [
    {
      // name: "Expense Date",
      name: <p style={{ fontSize: "12px" }}>Expense Date</p>,
      // selector: row => row.expenseDate,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.expenseDate}</span>
      ),
      sortable: true,
      sortField: 'expenseDate',
      // center: true,
      // style: { textAlign: 'left', paddingLeft: '10px' },

    },
    {
      // name: "Supplier Name",
      name: <p style={{ fontSize: "12px" }}>Supplier Name</p>,
      // selector: row => row.name,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.companyName}</span>
      ),
      sortable: true,
      sortField: 'companyName',
      // style: { paddingLeft: "10px" },
    },
    {
      // name: "Category Name",
      name: <p style={{ fontSize: "12px" }}>Account Name</p>,
      // selector: row => row.categoryCodeName,
      selector: row => (
        <span style={{ fontSize: "12px", }}>{row.categoryCodeName}</span>
      ),
      sortable: true,
      // center: true,
      sortField: 'categoryCodeName',
      // style: { paddingLeft: "10px" },
    },

    {
      // name: `Total Amount (${currencyCode})`,
      name: <p style={{ paddingLeft: "30px", fontSize: "12px" }}>{`Total Amount (${currencyCode})`}</p>,
      // selector: row => row.totalAmount,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{formatCurrencyAUD(row.totalAmount)}</span>
      ),

      sortable: true,
      sortField: 'totalAmount',
      center: true,
      // style: { paddingLeft: "10px" },
    },

    {
      // name: "Action(s)",
      name: <p style={{ fontSize: "12px" }}>Action(s)</p>,
      // selector: row => row._id,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row._id}</span>
      ),
      center: true,
      cell: row => <IconMenu size="small" row={
        <>
          {/* <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}> */}
          <Grid style={{ width: "100%" }} item>
            <Link
              to={`/expenses/editExpenses/${row._id}`} disabled={!screenAccess}
            >
              <p style={darkMode ? { color: "white" } : { color: "black" }}>
                <TimelineItem color="success"
                  //  icon="edit"
                  icon={<EditIcon className="actionicon" />}
                  title="Edit" />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit</p>
            </Link>
          </Grid>
          <Grid style={{ width: "100%" }} item >
            <p style={darkMode ? { color: "white" } : { color: "black" }} onClick={() => handleDeleteDialogeClick(row._id)} disabled={!screenAccess}>
              <TimelineItem
                color="error"
                // icon="delete"
                icon={<DeleteIcon className="actionicon" />}
                onClick={() => handleDeleteDialogeClick(row._id)}
                title="Delete"
              />  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delete</p>
          </Grid>
          {/* </Grid> */}
        </>
      } />,
    },
  ];

  const handleAddNew = () => {
    if (featureAccess) {
      if (!screenAccess) {
        showResMsg(genericMessage.notPermission, 2000, false);
      } else {
        navigate("/expenses/addExpenses");
      }
    }
    else {
      setShowBillingModal(true);
    }
  }



  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 350,
        overflowY: 'scroll',
      },
    },
  };
  const getSearchResult = useCallback(() => {
    fetchExpenses();
  }, [values.filterValues]);

  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (values.filterValues.length == "") {
      getSearchResult();

    }
  }, [values.filterValues]);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: '20px' }}>
        <Card color="primary">
          <PageTitle screenName="Expenses" />
          <Grid container display={"flex"} justifyContent="end" mt={2.2} gap={2} >
            <Grid lg={2.5} xs={6} >
              <FormControl fullWidth>
                <InputLabel id="Categories">Filter By Account</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "37.8px" }}
                  label="Filter By Account"
                  value={values.categoryCodeName}
                  onChange={(e) => setValues({ ...values, categoryCodeName: e.target.value })}
                  MenuProps={MenuProps}
                >
                  <MenuItem value="All">All</MenuItem>
                  {itemCategoriesName}
                </Select>
              </FormControl>
            </Grid>
            <Grid lg={2.5} xs={6} >
              <FormControl fullWidth>
                <InputLabel id="Categories">Filter By Supplier</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "37.8px" }}
                  label="Filter By Supplier"
                  value={values.name}
                  onChange={(e) => setValues({ ...values, name: e.target.value })}
                  MenuProps={MenuProps}
                >
                  <MenuItem value="All">All</MenuItem>
                  {contactTypeName}
                </Select>
              </FormControl>
            </Grid>
            <Grid lg={2.5} xs={6}>
              <TextField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                getSearchResult={getSearchResult}
                onKeyUp={(e) => {
                  if (e.key === "Enter") fetchExpenses();
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment  >
                      <Button style={{ borderRadius: "0px 0.3rem  0.3rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchExpenses} >
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <div style={{ marginRight: '16px' }}>
              <MDButton
                variant="contained"
                color="success"
                style={{ height: "38.11px" }}
                className={(!featureAccess || !screenAccess ? (darkMode ? "disabledInDarkMode" : "disabledInLightMode") : "")}
                onClick={handleAddNew}
              >
                Add New
              </MDButton>
            </div>
          </Grid>
          {/* <CardContent style={{height:`${rows.length > 10  ? '600px' : '450px'}`}}> */}
          <BTable
            theme={darkMode ? 'solarized' : 'light'}
            title={title}
            columns={columns}
            data={rows}
            selectable
            // selectableRows
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            customStyles={customStyles}
            // contextActions={contextActions}
            onSelectedRowsChange={handleRowSelected}
            clearSelectedRows={toggleCleared}

          />
          {/* </CardContent> */}
        </Card>
      </div >
      <DeleteModal
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
        message={deleteHeading}
      />
      <BillingModal
        open={showBillingModal}
        handleConfirm={() => { navigate('/subscriptions') }}
        handleCancel={() => { setShowBillingModal(false) }}
        closeModalClick={() => { setShowBillingModal(false) }}
        message={genericMessage.billingMsg}
        title={genericMessage.noCreditAvailableTitle}
      />
      <LoadingModal loading={loading} />

    </DashboardLayout>
  );

}

export default Expenses;